import { Component, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { TimeOffPolicy } from '@app/models/time-off-v3/time-off-policy.model';
import { MatSelect } from '@angular/material/select';
import { ControlContainer, NgForm } from '@angular/forms';
import { DaysKeys, WEEKLY } from '../../meta/time-off-meta';
import { TranslatableKey } from '@app/types/translatable.type';

@Component({
    selector: 'app-weekly-fields',
    templateUrl: './weekly-fields.template.html',
    styleUrls: ['./weekly-fields.style.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class WeeklyFieldsComponent implements OnDestroy {
    @Input() timeOffPolicy: TimeOffPolicy;
    @Input() accrualTimingField: MatSelect;
    @Input() containerClass = 'app-grid';
    @Input() fieldClass = 'columns-5 small-columns-12';
    @Input() firstDayOfPeriodLabel: TranslatableKey = 'time-off-v3.firstDayOfPeriod';
    @Output() requestPreviewParams: EventEmitter<string> = new EventEmitter();

    listOfWeekdays = DaysKeys;

    ngOnDestroy(): void {
        this.timeOffPolicy.resetDateValues(this.timeOffPolicy);
    }

    previewDataChanged(): void {
        this.requestPreviewParams.emit(WEEKLY);
    }
}
